/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext } from 'react';
import { Carousel } from '@one-thd/sui-carousel';
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  Link,
  Typography
} from '@one-thd/sui-atomic-components';
import PropTypes from 'prop-types';
import {
  ProductOverviewAccordionBody,
  ProductOverviewAccordionTitle
} from '@thd-olt-component-react/product-overview';
import {
  SpecificationsAccordionBody,
  SpecificationsAccordionTitle
} from '@thd-olt-component-react/specifications';
import { QuickViewContext } from '../utils/QuickViewProvider';
import { UnitList } from './UnitList';
import { UsedEquipmentPrice } from '../../UsedEquipmentPrice';
import { UsedEquipmentAvailability } from '../../UsedEquipmentAvailability';
import {
  getRawUnits
} from '../../used-equipment-helper';
import { sanitizeImageUrl } from '../utils/QuickViewUtils';

const { bool } = PropTypes;

export const QuickViewDetails = ({ paginateCarousel: _paginateCarousel }) => {
  const { item, itemDetail } = useContext(QuickViewContext);

  // Prefer inventory title so quick view matches the grid card naming.
  // Catalog productLabel can include extra qualifiers (for example, "rental").
  const title = item?.title || itemDetail?.identifiers?.productLabel || item?.SubCategoryDesc;
  const brand = itemDetail?.identifiers?.brandName;
  const images = itemDetail?.media?.images || [];
  const itemId = itemDetail?.itemId;
  const unitRows = getRawUnits(item);

  return (
    <>
      {brand && (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <Link href="#" underline="always" className="sui-text-sm">
          {brand}
        </Link>
      )}
      <Typography variant="h3" weight="bold" height="tight">
        {title}
      </Typography>

      {/* Image Carousel */}
      {images && images.length > 0 && (
        <div className="sui-overflow-hidden sui-mt-6 sui-mb-2 sui-relative sui-z-0">
          <Carousel type="hero">
            {images.map((image, i) => (
              <img
                key={`quickview-details-carousel-image-${i}`}
                alt={image.type || 'product'}
                src={sanitizeImageUrl(image.url)}
                width="400"
                height="400"
                className="sui-w-full sui-aspect-square sui-object-cover"
              />
            ))}
          </Carousel>
        </div>
      )}

      {/* Price and Availability */}
      <div className="sui-flex sui-flex-col sui-gap-2 sui-mt-4">
        <UsedEquipmentPrice item={item} type="detailed" />
        <UsedEquipmentAvailability item={item} />
      </div>

      <UnitList units={unitRows} />

      {/* Accordion Sections */}
      {itemId && (
        <div className="sui-mt-6 sui-flex sui-flex-col sui-gap-2">
          {/* Product Details Accordion */}
          <Accordion>
            <AccordionHeader>
              <ProductOverviewAccordionTitle />
            </AccordionHeader>
            <AccordionBody>
              <ProductOverviewAccordionBody itemId={itemId} forceMobile />
            </AccordionBody>
          </Accordion>

          {/* Specifications Accordion */}
          <Accordion>
            <AccordionHeader>
              <SpecificationsAccordionTitle itemId={itemId} showSubtitle={false} />
            </AccordionHeader>
            <AccordionBody>
              <SpecificationsAccordionBody itemId={itemId} oneColumn />
            </AccordionBody>
          </Accordion>
        </div>
      )}
    </>
  );
};

QuickViewDetails.propTypes = {
  paginateCarousel: bool
};

QuickViewDetails.defaultProps = {
  paginateCarousel: true
};
